module.exports = __webpack_public_path__ + "static/img/icon_pregrant.466aeb26.png";